import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { ChakraProvider } from '@chakra-ui/react';

import Game from "./pages/Game";
import Home from "./pages/Home";
import Overview from "./pages/Overview";
import Conclusion from "./pages/Conclusion";

import BoxOne from "./pages/BoxOne/BoxOne";
import BoxTwo from "./pages/BoxTwo/BoxTwo";
import BoxThree from "./pages/BoxThree/BoxThree";

import PuzzleOne from "./pages/BoxOne/PuzzleOne";
import PuzzleTwo from "./pages/BoxOne/PuzzleTwo";
import PuzzleThree from "./pages/BoxTwo/PuzzleThree";
import PuzzleFour from "./pages/BoxThree/PuzzleFour";
import PuzzleFive from "./pages/BoxThree/PuzzleFive";
import PuzzleFiveTwo from "./pages/BoxThree/PuzzleFiveTwo";

import ContextOne from "./pages/BoxOne/ContextOne";
import ContextOneTwo from "./pages/BoxOne/ContextOneTwo";
import ContextTwo from "./pages/BoxOne/ContextTwo";
import ContextFour from "./pages/BoxTwo/ContextFour";
import ContextFive from "./pages/BoxThree/ContextFive";
import ContextSix from "./pages/BoxThree/ContextSix";

import './App.css';

function App() {
    return (
        <ChakraProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Game />} >
                        <Route index element={<Home />} />
                        <Route path="Overview" element={<Overview />} />
                        <Route path="BoxOne" element={<Outlet />} >
                            <Route index element={<BoxOne />} />
                            <Route path="ContextOne" element={<ContextOne />} />
                            <Route path="ContextOneTwo" element={<ContextOneTwo />} />
                            <Route path="PuzzleOne" element={<PuzzleOne />} />
                            <Route path="ContextTwo" element={<ContextTwo />} />
                            <Route path="PuzzleTwo" element={<PuzzleTwo />} />
                        </Route>
                        <Route path="BoxTwo" element={<Outlet />} >
                            <Route index element={<BoxTwo />} />
                            <Route path="PuzzleThree" element={<PuzzleThree />} />
                            <Route path="ContextFour" element={<ContextFour />} />                     
                        </Route>
                        <Route path="BoxThree" element={<Outlet />} >
                          <Route index element={<BoxThree />} />
                          <Route path="PuzzleFour" element={<PuzzleFour />} />
                          <Route path="ContextFive" element={<ContextFive />} />
                          <Route path="PuzzleFive" element={<PuzzleFive />} />
                          <Route path="PuzzleFiveTwo" element={<PuzzleFiveTwo />} />
                          <Route path="ContextSix" element={<ContextSix />} />
                        </Route>
                        <Route path="Conclusion" element={<Conclusion />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </ChakraProvider>
    );
}

export default App;
